module.exports = __webpack_public_path__ + "94bf318f7a0ae121fd1c701646bc7a3c.pdf";